import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useStateValue } from '../state'
import { payments as endpoints } from '../../api_urls'
import { client } from '../../utils'
import NewPaymentFormInputs from './NewPaymentFormInputs'
import ButterToast, { Cinnamon } from 'butter-toast'

const NewPaymentModal = () => {
  const [currentState, dispatch] = useStateValue()
  const [working, toggleWorking] = useState(false)

  const handleFormSubmit = async () => {
    toggleWorking(true)
    let data = {
      description: currentState.newPaymentDescription,
      amount: currentState.newPaymentAmount,
      stripe_transaction_id: currentState.newPaymentTransactionID,
      coursenum: currentState.newPaymentCoursenum,
      source: currentState.newSource,
      invoice_number: currentState.newInvoiceNumber,
    }
    client
      .post(endpoints.createNewPayment(), data)
      .then(resp => {
        toggleWorking(false)
        dispatch({ type: 'newPaymentModalOpen', newPaymentModalOpen: false })
        dispatch({
          type: 'updateCommissions',
          commissions: resp.data.commissions,
        })
        dispatch({
          type: 'updatePaymentItemId',
          paymentItemId: resp.data.payment_item_id,
        })
        dispatch({
          type: 'updateSalespeople',
          salespeople: resp.data.salespeople,
        })
        if (resp.data.stripe_connect_course === 'yes') {
          dispatch({
            type: 'updateRoyaltiesOwed',
            royaltiesOwed: resp.data.royalties,
          })
          dispatch({
            type: 'toggleRoyaltyPaymentModal',
            royaltyModalOpen: true,
          })
        } else {
          dispatch({
            type: 'toggleCommissionPaymentModal',
            commissionModalOpen: true,
          })
        }
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Success"
              content={`Payment saved successfully.`}
              scheme={Cinnamon.Crisp.SCHEME_GREEN}
              icon={<i className="far fa-check fa-3x" />}
            />
          ),
        })
      })
      .catch(err => {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
        toggleWorking(false)
      })
  }

  const closeModal = () => {
    dispatch({ type: 'newPaymentModalOpen', newPaymentModalOpen: false })
    dispatch({ type: 'resetFormData' })
    toggleWorking(false)
  }

  return (
    <Modal show={currentState.newPaymentModalOpen}>
      <Modal.Header>
        <Modal.Title>Add New Payment</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <NewPaymentFormInputs />
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => closeModal()}
          className="btn-myed btn-default-myed"
        >
          <span className="far fa-times fa-fw mr-2" />
          Cancel
        </Button>
        <Button
          bsStyle="success"
          className="btn-myed btn-success-myed"
          onClick={() => handleFormSubmit()}
          disabled={working}
        >
          <span
            className={
              !working
                ? 'far fa-check fa-fw mr-2'
                : 'far fa-spinner fa-spin fa-fw mr-2'
            }
          />
          Save Payment
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NewPaymentModal
